import React from 'react'
import {Link} from 'gatsby'

const Legals = () => {

    const currentYear = new Date().getFullYear();

    return (
        <footer className="legals-area bg-color">
            <div className="container">
                <div>
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <p>Copyright @{currentYear} <strong>Tell Money Limited</strong> All rights reserved</p>
                        </div>

                        <div className="col-lg-6 col-md-6 legals-nav">
                            <ul>
                                <li>
                                    <Link to="/privacy-policy/">
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/terms-of-service/">
                                        Terms & Conditions
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

         
        </footer>
    );
}

export default Legals;